import axios from 'axios';
import authHeader from './auth-header';
import config from '../config';

class WithdrawalService {
  // Create withdrawal request
  createWithdrawal(amount, walletType, walletDetails, fundPassword) {
    return axios.post(config.api.withdrawal + '/create', {
      amount,
      walletType,
      walletDetails,
      fundPassword
    }, {
      headers: authHeader()
    });
  }

  // Get user's withdrawal history
  getUserWithdrawals() {
    const user = JSON.parse(localStorage.getItem('user'));
    const username = user ? user.username : '';
    return axios.get(config.api.withdrawal + '/user/' + username, {
      headers: authHeader()
    });
  }

  // Admin: Get all withdrawal requests
  getAllWithdrawals() {
    return axios.get(config.api.admin + '/withdrawals', {
      headers: authHeader()
    });
  }

  // Admin: Approve withdrawal
  approveWithdrawal(withdrawalId) {
    return axios.post(config.api.admin + '/withdrawal/approve', { withdrawalId }, {
      headers: authHeader()
    });
  }

  // Admin: Reject withdrawal
  rejectWithdrawal(withdrawalId) {
    return axios.post(config.api.admin + '/withdrawal/reject', { withdrawalId }, {
      headers: authHeader()
    });
  }
}

export default new WithdrawalService();